import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=18b43b23&scoped=true&"
import script from "./Blog.vue?vue&type=script&lang=js&"
export * from "./Blog.vue?vue&type=script&lang=js&"
import style0 from "./Blog.vue?vue&type=style&index=0&id=18b43b23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b43b23",
  null
  
)

export default component.exports